$(document).on("click", ".PostStream-item a[href*='.jpeg'], .PostStream-item a[href*='.png'], .PostStream-item a[href*='.jpg'], .PostStream-item a[href*='.gif'], .PostStream-item a[href*='.JPEG'], .PostStream-item a[href*='.PNG'], .PostStream-item a[href*='.JPG'], .PostStream-item a[href*='.GIF']", function (e) {
	var $this = $(this);

	$.magnificPopup.open({
		items: {
			src: $this.attr('href'),
		},
		type: 'image',
		zoom: {
			enabled: true,
			opener: function () {
				return $this.find('img');
			},
		},
	});
	e.preventDefault();
})
